{
  "items": [
    {
      "city": "Vilnius",
      "lat": "54.6833",
      "lng": "25.2833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilniaus Miestas",
      "capital": "primary",
      "population": "574147",
      "population_proper": "574147"
    },
    {
      "city": "Kaunas",
      "lat": "54.9000",
      "lng": "23.9333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kauno Miestas",
      "capital": "admin",
      "population": "288466",
      "population_proper": "288466"
    },
    {
      "city": "Klaipėda",
      "lat": "55.7075",
      "lng": "21.1428",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Klaipėdos Miestas",
      "capital": "admin",
      "population": "164310",
      "population_proper": "164310"
    },
    {
      "city": "Šiauliai",
      "lat": "55.9281",
      "lng": "23.3167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šiaulių Miestas",
      "capital": "admin",
      "population": "107086",
      "population_proper": "107086"
    },
    {
      "city": "Panevėžys",
      "lat": "55.7250",
      "lng": "24.3639",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Panevėžio Miestas",
      "capital": "admin",
      "population": "91054",
      "population_proper": "91054"
    },
    {
      "city": "Alytus",
      "lat": "54.4014",
      "lng": "24.0492",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Alytaus Miestas",
      "capital": "admin",
      "population": "49888",
      "population_proper": "49888"
    },
    {
      "city": "Marijampolė",
      "lat": "54.5567",
      "lng": "23.3544",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Marijampolė",
      "capital": "admin",
      "population": "34968",
      "population_proper": "34968"
    },
    {
      "city": "Mažeikiai",
      "lat": "56.3111",
      "lng": "22.3361",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Mažeikiai",
      "capital": "admin",
      "population": "32477",
      "population_proper": "32477"
    },
    {
      "city": "Utena",
      "lat": "55.5000",
      "lng": "25.6028",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Utena",
      "capital": "admin",
      "population": "26491",
      "population_proper": "26491"
    },
    {
      "city": "Jonava",
      "lat": "55.0722",
      "lng": "24.2806",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Jonava",
      "capital": "admin",
      "population": "26427",
      "population_proper": "26427"
    },
    {
      "city": "Kėdainiai",
      "lat": "55.2833",
      "lng": "23.9667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kėdainiai",
      "capital": "admin",
      "population": "22682",
      "population_proper": "22682"
    },
    {
      "city": "Telšiai",
      "lat": "55.9833",
      "lng": "22.2500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Telšiai",
      "capital": "admin",
      "population": "22039",
      "population_proper": "22039"
    },
    {
      "city": "Tauragė",
      "lat": "55.2514",
      "lng": "22.2903",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Tauragė",
      "capital": "admin",
      "population": "21516",
      "population_proper": "21516"
    },
    {
      "city": "Ukmergė",
      "lat": "55.2667",
      "lng": "24.7500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Ukmergė",
      "capital": "admin",
      "population": "21226",
      "population_proper": "21226"
    },
    {
      "city": "Visaginas",
      "lat": "55.6000",
      "lng": "26.4333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Visaginas",
      "capital": "admin",
      "population": "18514",
      "population_proper": "18514"
    },
    {
      "city": "Plungė",
      "lat": "55.9167",
      "lng": "21.8500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Plungė",
      "capital": "admin",
      "population": "16750",
      "population_proper": "16750"
    },
    {
      "city": "Kretinga",
      "lat": "55.8758",
      "lng": "21.2508",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kretinga",
      "capital": "admin",
      "population": "16580",
      "population_proper": "16580"
    },
    {
      "city": "Šilutė",
      "lat": "55.3500",
      "lng": "21.4833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šilutė",
      "capital": "admin",
      "population": "15902",
      "population_proper": "15902"
    },
    {
      "city": "Palanga",
      "lat": "55.9167",
      "lng": "21.0639",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Palangos Miestas",
      "capital": "admin",
      "population": "15381",
      "population_proper": "15381"
    },
    {
      "city": "Radviliškis",
      "lat": "55.8000",
      "lng": "23.5500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Radviliškis",
      "capital": "admin",
      "population": "15275",
      "population_proper": "15275"
    },
    {
      "city": "Gargždai",
      "lat": "55.7000",
      "lng": "21.4000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Klaipėda",
      "capital": "",
      "population": "14402",
      "population_proper": "14402"
    },
    {
      "city": "Rokiškis",
      "lat": "55.9616",
      "lng": "25.5807",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Rokiškis",
      "capital": "admin",
      "population": "12738",
      "population_proper": "12738"
    },
    {
      "city": "Druskininkai",
      "lat": "54.0206",
      "lng": "23.9725",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Druskininkai",
      "capital": "admin",
      "population": "12055",
      "population_proper": "12055"
    },
    {
      "city": "Elektrėnai",
      "lat": "54.7886",
      "lng": "24.6612",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Elektrénai",
      "capital": "admin",
      "population": "11588",
      "population_proper": "11588"
    },
    {
      "city": "Kuršėnai",
      "lat": "55.9979",
      "lng": "22.9415",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šiauliai",
      "capital": "",
      "population": "10829",
      "population_proper": "10829"
    },
    {
      "city": "Grigiškės",
      "lat": "54.6694",
      "lng": "25.0944",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilniaus Miestas",
      "capital": "",
      "population": "10815",
      "population_proper": "10815"
    },
    {
      "city": "Biržai",
      "lat": "56.2000",
      "lng": "24.7500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Biržai",
      "capital": "admin",
      "population": "10146",
      "population_proper": "10146"
    },
    {
      "city": "Lentvaris",
      "lat": "54.6436",
      "lng": "25.0517",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Trakai",
      "capital": "",
      "population": "10000",
      "population_proper": "10000"
    },
    {
      "city": "Garliava",
      "lat": "54.8167",
      "lng": "23.8667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "9873",
      "population_proper": "9873"
    },
    {
      "city": "Jurbarkas",
      "lat": "55.0778",
      "lng": "22.7756",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Jurbarkas",
      "capital": "admin",
      "population": "9711",
      "population_proper": "9711"
    },
    {
      "city": "Vilkaviškis",
      "lat": "54.6667",
      "lng": "23.0333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilkaviškis",
      "capital": "admin",
      "population": "9444",
      "population_proper": "9444"
    },
    {
      "city": "Joniškis",
      "lat": "56.2433",
      "lng": "23.6179",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Joniškis",
      "capital": "admin",
      "population": "8757",
      "population_proper": "8757"
    },
    {
      "city": "Anykščiai",
      "lat": "55.5344",
      "lng": "25.1072",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Anykščiai",
      "capital": "admin",
      "population": "8491",
      "population_proper": "8491"
    },
    {
      "city": "Varėna",
      "lat": "54.2111",
      "lng": "24.5722",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Varėna",
      "capital": "admin",
      "population": "8477",
      "population_proper": "8477"
    },
    {
      "city": "Prienai",
      "lat": "54.6333",
      "lng": "23.9417",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Prienai",
      "capital": "admin",
      "population": "8451",
      "population_proper": "8451"
    },
    {
      "city": "Kelmė",
      "lat": "55.6333",
      "lng": "22.9333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kelmė",
      "capital": "admin",
      "population": "7499",
      "population_proper": "7499"
    },
    {
      "city": "Naujoji Akmenė",
      "lat": "56.3250",
      "lng": "22.8833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Akmenė",
      "capital": "admin",
      "population": "7194",
      "population_proper": "7194"
    },
    {
      "city": "Šalčininkai",
      "lat": "54.3111",
      "lng": "25.3806",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šalčininkai",
      "capital": "admin",
      "population": "6715",
      "population_proper": "6715"
    },
    {
      "city": "Pasvalys",
      "lat": "56.0611",
      "lng": "24.4028",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Pasvalys",
      "capital": "admin",
      "population": "6361",
      "population_proper": "6361"
    },
    {
      "city": "Zarasai",
      "lat": "55.7306",
      "lng": "26.2472",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Zarasai",
      "capital": "admin",
      "population": "6051",
      "population_proper": "6051"
    },
    {
      "city": "Kupiškis",
      "lat": "55.8333",
      "lng": "24.9667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kupiškis",
      "capital": "admin",
      "population": "5907",
      "population_proper": "5907"
    },
    {
      "city": "Kazlų Rūda",
      "lat": "54.7492",
      "lng": "23.4865",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kazlų Rūdos",
      "capital": "admin",
      "population": "5539",
      "population_proper": "5539"
    },
    {
      "city": "Molėtai",
      "lat": "55.2333",
      "lng": "25.4167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Molėtai",
      "capital": "admin",
      "population": "5497",
      "population_proper": "5497"
    },
    {
      "city": "Pabradė",
      "lat": "54.9806",
      "lng": "25.7667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Švenčionys",
      "capital": "",
      "population": "5339",
      "population_proper": "5339"
    },
    {
      "city": "Skuodas",
      "lat": "56.2667",
      "lng": "21.5333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Skuodas",
      "capital": "admin",
      "population": "5083",
      "population_proper": "5083"
    },
    {
      "city": "Domeikava",
      "lat": "54.9667",
      "lng": "23.9167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "5006",
      "population_proper": "5006"
    },
    {
      "city": "Šakiai",
      "lat": "54.9556",
      "lng": "23.0444",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šakiai",
      "capital": "admin",
      "population": "4998",
      "population_proper": "4998"
    },
    {
      "city": "Švenčionėliai",
      "lat": "55.1667",
      "lng": "26.0000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Švenčionys",
      "capital": "",
      "population": "4726",
      "population_proper": "4726"
    },
    {
      "city": "Šilalė",
      "lat": "55.4917",
      "lng": "22.1778",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šilalė",
      "capital": "admin",
      "population": "4640",
      "population_proper": "4640"
    },
    {
      "city": "Pakruojis",
      "lat": "55.9809",
      "lng": "23.8551",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Pakruojis",
      "capital": "admin",
      "population": "4632",
      "population_proper": "4632"
    },
    {
      "city": "Vievis",
      "lat": "54.7736",
      "lng": "24.8164",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Elektrénai",
      "capital": "",
      "population": "4552",
      "population_proper": "4552"
    },
    {
      "city": "Kybartai",
      "lat": "54.6389",
      "lng": "22.7556",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilkaviškis",
      "capital": "",
      "population": "4461",
      "population_proper": "4461"
    },
    {
      "city": "Trakai",
      "lat": "54.6333",
      "lng": "24.9333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Trakai",
      "capital": "admin",
      "population": "4430",
      "population_proper": "4430"
    },
    {
      "city": "Raudondvaris",
      "lat": "54.9431",
      "lng": "23.7833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "4142",
      "population_proper": "4142"
    },
    {
      "city": "Skaidiškės",
      "lat": "54.6081",
      "lng": "25.3861",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "4133",
      "population_proper": "4133"
    },
    {
      "city": "Švenčionys",
      "lat": "55.1333",
      "lng": "26.1556",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Švenčionys",
      "capital": "admin",
      "population": "4065",
      "population_proper": "4065"
    },
    {
      "city": "Rudamina",
      "lat": "54.5972",
      "lng": "25.3500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "3981",
      "population_proper": "3981"
    },
    {
      "city": "Kalvarija",
      "lat": "54.4147",
      "lng": "23.2281",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kalvarijos",
      "capital": "admin",
      "population": "3766",
      "population_proper": "3766"
    },
    {
      "city": "Lazdijai",
      "lat": "54.2319",
      "lng": "23.5170",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Lazdijai",
      "capital": "admin",
      "population": "3629",
      "population_proper": "3629"
    },
    {
      "city": "Pagiriai",
      "lat": "54.5789",
      "lng": "25.1983",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "3451",
      "population_proper": "3451"
    },
    {
      "city": "Žiežmariai",
      "lat": "54.8056",
      "lng": "24.4389",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaišiadorys",
      "capital": "",
      "population": "3268",
      "population_proper": "3268"
    },
    {
      "city": "Pervalka",
      "lat": "55.5556",
      "lng": "21.1167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Neringa",
      "capital": "",
      "population": "3224",
      "population_proper": "3224"
    },
    {
      "city": "Rietavas",
      "lat": "55.7250",
      "lng": "21.9278",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Rietavo",
      "capital": "admin",
      "population": "3149",
      "population_proper": "3149"
    },
    {
      "city": "Ringaudai",
      "lat": "54.8861",
      "lng": "23.8031",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "2861",
      "population_proper": "2861"
    },
    {
      "city": "Ariogala",
      "lat": "55.2639",
      "lng": "23.4694",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Raseiniai",
      "capital": "",
      "population": "2760",
      "population_proper": "2760"
    },
    {
      "city": "Didžioji Reišė",
      "lat": "54.8028",
      "lng": "25.2639",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilniaus Apskritis",
      "capital": "",
      "population": "2520",
      "population_proper": "2520"
    },
    {
      "city": "Nemėžis",
      "lat": "54.6361",
      "lng": "25.3611",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "2498",
      "population_proper": "2498"
    },
    {
      "city": "Akmenė",
      "lat": "56.2500",
      "lng": "22.7500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Akmenė",
      "capital": "",
      "population": "2429",
      "population_proper": "2429"
    },
    {
      "city": "Dembava",
      "lat": "55.7310",
      "lng": "24.4060",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Panevėžys",
      "capital": "",
      "population": "2397",
      "population_proper": "2397"
    },
    {
      "city": "Nida",
      "lat": "55.3040",
      "lng": "21.0053",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Neringa",
      "capital": "admin",
      "population": "2385",
      "population_proper": "2385"
    },
    {
      "city": "Birštonas",
      "lat": "54.6056",
      "lng": "24.0292",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Birštono",
      "capital": "admin",
      "population": "2331",
      "population_proper": "2331"
    },
    {
      "city": "Pilviškiai",
      "lat": "54.7222",
      "lng": "23.2222",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilkaviškis",
      "capital": "",
      "population": "2305",
      "population_proper": "2305"
    },
    {
      "city": "Venta",
      "lat": "56.1944",
      "lng": "22.7000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Akmenė",
      "capital": "",
      "population": "2168",
      "population_proper": "2168"
    },
    {
      "city": "Viekšniai",
      "lat": "56.2389",
      "lng": "22.5139",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Mažeikiai",
      "capital": "",
      "population": "2126",
      "population_proper": "2126"
    },
    {
      "city": "Avižieniai",
      "lat": "54.7639",
      "lng": "25.1831",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "2125",
      "population_proper": "2125"
    },
    {
      "city": "Rukla",
      "lat": "55.0528",
      "lng": "24.3778",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Jonava",
      "capital": "",
      "population": "2098",
      "population_proper": "2098"
    },
    {
      "city": "Valčiūnai",
      "lat": "54.5611",
      "lng": "25.2639",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "2089",
      "population_proper": "2089"
    },
    {
      "city": "Baisogala",
      "lat": "55.6389",
      "lng": "23.7222",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Radviliškis",
      "capital": "",
      "population": "2034",
      "population_proper": "2034"
    },
    {
      "city": "Taurai",
      "lat": "55.2390",
      "lng": "22.2500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Tauragė",
      "capital": "",
      "population": "1891",
      "population_proper": "1891"
    },
    {
      "city": "Tytuvėnai",
      "lat": "55.6000",
      "lng": "23.2000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kelmė",
      "capital": "",
      "population": "1841",
      "population_proper": "1841"
    },
    {
      "city": "Viečiūnai",
      "lat": "54.0583",
      "lng": "24.0528",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Druskininkai",
      "capital": "",
      "population": "1708",
      "population_proper": "1708"
    },
    {
      "city": "Teleičiai",
      "lat": "54.8440",
      "lng": "23.8830",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1700",
      "population_proper": "1700"
    },
    {
      "city": "Viduklė",
      "lat": "55.4028",
      "lng": "22.8972",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Raseiniai",
      "capital": "",
      "population": "1678",
      "population_proper": "1678"
    },
    {
      "city": "Švėkšna",
      "lat": "55.5167",
      "lng": "21.6278",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šilutė",
      "capital": "",
      "population": "1649",
      "population_proper": "1649"
    },
    {
      "city": "Krekenava",
      "lat": "55.5500",
      "lng": "24.1000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Panevėžys",
      "capital": "",
      "population": "1636",
      "population_proper": "1636"
    },
    {
      "city": "Gelgaudiškis",
      "lat": "55.0833",
      "lng": "22.9833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šakiai",
      "capital": "",
      "population": "1622",
      "population_proper": "1622"
    },
    {
      "city": "Karmėlava II",
      "lat": "54.9750",
      "lng": "24.0750",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1585",
      "population_proper": "1585"
    },
    {
      "city": "Ramučiai",
      "lat": "54.9472",
      "lng": "24.0306",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1583",
      "population_proper": "1583"
    },
    {
      "city": "Ežerėlis",
      "lat": "54.8833",
      "lng": "23.6167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1579",
      "population_proper": "1579"
    },
    {
      "city": "Babtai",
      "lat": "55.0917",
      "lng": "23.7944",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1563",
      "population_proper": "1563"
    },
    {
      "city": "Josvainiai",
      "lat": "55.2500",
      "lng": "23.8333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kėdainiai",
      "capital": "",
      "population": "1545",
      "population_proper": "1545"
    },
    {
      "city": "Žagarė",
      "lat": "56.3583",
      "lng": "23.2500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Joniškis",
      "capital": "",
      "population": "1453",
      "population_proper": "1453"
    },
    {
      "city": "Kudirkos Naumiestis",
      "lat": "54.7750",
      "lng": "22.8667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šakiai",
      "capital": "",
      "population": "1444",
      "population_proper": "1444"
    },
    {
      "city": "Ramygala",
      "lat": "55.5111",
      "lng": "24.3028",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Panevėžys",
      "capital": "",
      "population": "1440",
      "population_proper": "1440"
    },
    {
      "city": "Kulautuva",
      "lat": "54.9389",
      "lng": "23.6500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaunas",
      "capital": "",
      "population": "1425",
      "population_proper": "1425"
    },
    {
      "city": "Skaudvilė",
      "lat": "55.4075",
      "lng": "22.5825",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Tauragė",
      "capital": "",
      "population": "1425",
      "population_proper": "1425"
    },
    {
      "city": "Senieji Trakai",
      "lat": "54.6167",
      "lng": "24.9667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Trakai",
      "capital": "",
      "population": "1396",
      "population_proper": "1396"
    },
    {
      "city": "Salantai",
      "lat": "56.0667",
      "lng": "21.5667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kretinga",
      "capital": "",
      "population": "1362",
      "population_proper": "1362"
    },
    {
      "city": "Vilainiai",
      "lat": "55.3000",
      "lng": "24.0031",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kėdainiai",
      "capital": "",
      "population": "1330",
      "population_proper": "1330"
    },
    {
      "city": "Padvariai",
      "lat": "55.9083",
      "lng": "21.2833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kretinga",
      "capital": "",
      "population": "1308",
      "population_proper": "1308"
    },
    {
      "city": "Didžiasalis",
      "lat": "55.3194",
      "lng": "26.6806",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Ignalina",
      "capital": "",
      "population": "1299",
      "population_proper": "1299"
    },
    {
      "city": "Veisiejai",
      "lat": "54.1011",
      "lng": "23.6961",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Lazdijai",
      "capital": "",
      "population": "1267",
      "population_proper": "1267"
    },
    {
      "city": "Linkuva",
      "lat": "56.0889",
      "lng": "23.9722",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Pakruojis",
      "capital": "",
      "population": "1246",
      "population_proper": "1246"
    },
    {
      "city": "Riešė",
      "lat": "54.8083",
      "lng": "25.2389",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "1234",
      "population_proper": "1234"
    },
    {
      "city": "Priekulė",
      "lat": "55.5556",
      "lng": "21.3194",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Klaipėda",
      "capital": "",
      "population": "1231",
      "population_proper": "1231"
    },
    {
      "city": "Galgiai",
      "lat": "54.7250",
      "lng": "25.4120",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "1230",
      "population_proper": "1230"
    },
    {
      "city": "Matuizos",
      "lat": "54.2833",
      "lng": "24.6833",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Varėna",
      "capital": "",
      "population": "1201",
      "population_proper": "1201"
    },
    {
      "city": "Simnas",
      "lat": "54.4000",
      "lng": "23.6500",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Alytus",
      "capital": "",
      "population": "1198",
      "population_proper": "1198"
    },
    {
      "city": "Ylakiai",
      "lat": "56.2780",
      "lng": "21.8566",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Skuodas",
      "capital": "",
      "population": "1165",
      "population_proper": "1165"
    },
    {
      "city": "Kairiai",
      "lat": "55.9167",
      "lng": "23.4389",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šiauliai",
      "capital": "",
      "population": "1158",
      "population_proper": "1158"
    },
    {
      "city": "Piniava",
      "lat": "55.7810",
      "lng": "24.3610",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Panevėžys",
      "capital": "",
      "population": "1158",
      "population_proper": "1158"
    },
    {
      "city": "Varniai",
      "lat": "55.7333",
      "lng": "22.3667",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Telšiai",
      "capital": "",
      "population": "1140",
      "population_proper": "1140"
    },
    {
      "city": "Laukuva",
      "lat": "55.6194",
      "lng": "22.2333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šilalė",
      "capital": "",
      "population": "1140",
      "population_proper": "1140"
    },
    {
      "city": "Dovilai",
      "lat": "55.6778",
      "lng": "21.3556",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Klaipėda",
      "capital": "",
      "population": "1100",
      "population_proper": "1100"
    },
    {
      "city": "Veiveriai",
      "lat": "54.7639",
      "lng": "23.7250",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Prienai",
      "capital": "",
      "population": "1100",
      "population_proper": "1100"
    },
    {
      "city": "Užtiltė",
      "lat": "55.7390",
      "lng": "25.8280",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Zarasai",
      "capital": "",
      "population": "1100",
      "population_proper": "1100"
    },
    {
      "city": "Vidiškės",
      "lat": "55.3750",
      "lng": "26.2111",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Ignalina",
      "capital": "",
      "population": "1084",
      "population_proper": "1084"
    },
    {
      "city": "Gineitiškės",
      "lat": "54.7390",
      "lng": "25.2000",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Vilnius",
      "capital": "",
      "population": "1082",
      "population_proper": "1082"
    },
    {
      "city": "Baltoji Vokė",
      "lat": "54.4500",
      "lng": "25.1333",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šalčininkai",
      "capital": "",
      "population": "1056",
      "population_proper": "1056"
    },
    {
      "city": "Liudvinavas",
      "lat": "54.4833",
      "lng": "23.3528",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Marijampolė",
      "capital": "",
      "population": "1055",
      "population_proper": "1055"
    },
    {
      "city": "Miklusėnai",
      "lat": "54.4417",
      "lng": "23.9972",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Alytus",
      "capital": "",
      "population": "1044",
      "population_proper": "1044"
    },
    {
      "city": "Mokolai",
      "lat": "54.5720",
      "lng": "23.3390",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Marijampolė",
      "capital": "",
      "population": "1031",
      "population_proper": "1031"
    },
    {
      "city": "Plateliai",
      "lat": "56.0500",
      "lng": "21.8167",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Plungė",
      "capital": "",
      "population": "1021",
      "population_proper": "1021"
    },
    {
      "city": "Joniškėlis",
      "lat": "56.0250",
      "lng": "24.1694",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Pasvalys",
      "capital": "",
      "population": "1021",
      "population_proper": "1021"
    },
    {
      "city": "Drąsučiai",
      "lat": "56.0330",
      "lng": "22.9810",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Šiauliai",
      "capital": "",
      "population": "1004",
      "population_proper": "1004"
    },
    {
      "city": "Širvintos",
      "lat": "55.0470",
      "lng": "24.9420",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Širvintos",
      "capital": "admin",
      "population": "744",
      "population_proper": "744"
    },
    {
      "city": "Pagėgiai",
      "lat": "55.1328",
      "lng": "21.8778",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Pagégiai",
      "capital": "admin",
      "population": "57",
      "population_proper": "57"
    },
    {
      "city": "Kaišiadorys",
      "lat": "54.8653",
      "lng": "24.4682",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Kaišiadorys",
      "capital": "admin",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Raseiniai",
      "lat": "55.3797",
      "lng": "23.1239",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Raseiniai",
      "capital": "admin",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Ignalina",
      "lat": "55.3406",
      "lng": "26.1605",
      "country": "Lithuania",
      "iso2": "LT",
      "admin_name": "Ignalina",
      "capital": "admin",
      "population": "",
      "population_proper": ""
    }
  ]
}
